import { SET } from "@/stores/CommumActionTypes";
import { UPDATE_USER_IMG_URL } from "./UserActionTypes";

const mutations = {
	[SET]: (state, user) =>
	{
		state.user = user;
	},
	[UPDATE_USER_IMG_URL]: (state, url) =>
	{
		state.profileImgUrl = url;
	},
};

export default { mutations };
